import * as React from 'react';
import { useState } from 'react';
import { styled } from 'styled-components';
import Tile from '../../common/Tile';
import { publicClientBasicInfoPageUrl, publicClientJoinPageUrl } from '../../../core/constants';
import Helmet from '../../../commonComponents/Helmet';
import PublicAutoLogoutLayout, { TitleParagraph } from './common/PublicLayout';
import PublicFormButtons from './common/PublicFormButtons';
import PublicSquareButton from './common/PublicSquareButton';
import building from '../../../images/building.svg';
import person from '../../../images/person.svg';
import { useProgress, useRequireProgress } from './common/PublicProgressContext';
import {
	ctxTermsAccepted,
	ctxClientTypeSelected,
	individualClientType,
	businessOwnerClientType
} from './common/publicConstants';
import { useNavigateWithAppName } from '../../common/NavigateWithAppName';

const PublicClientTypeSelectionPage = () => {
	const navigate = useNavigateWithAppName();
	const { updateProgress } = useProgress();
	const [selectedButton, setSelectedButton] = useState('');

	// Ensure the user has accepted the terms before allowing access to this page.
	// If terms are not accepted, the user will be redirected to the appropriate page.
	useRequireProgress([ctxTermsAccepted]);

	const handleClientTypeButtonClick = (buttonId: string) => {
		setSelectedButton(buttonId);
	};

	const handleBackButtonClick = () => {
		navigate(publicClientJoinPageUrl);
	};

	const handleContinueButtonClick = () => {
		updateProgress(ctxClientTypeSelected, selectedButton);
		navigate(publicClientBasicInfoPageUrl);
	};

	return (
		<PublicAutoLogoutLayout>
			<Helmet>
				<title>Join Kelly+Partners | Prospective Client</title>
			</Helmet>
			<Tile>
				<TitleParagraph $bold>Which of the following best describes you?</TitleParagraph>
				<StyledSquareButtonContainer>
					<PublicSquareButton
						logo={building}
						mainText={businessOwnerClientType}
						subText="I own and operate a private business."
						selected={selectedButton === businessOwnerClientType}
						onClick={() => handleClientTypeButtonClick(businessOwnerClientType)}
					/>
					<PublicSquareButton
						logo={person}
						mainText={individualClientType}
						subText="I’m a high-net-worth individual."
						selected={selectedButton === individualClientType}
						onClick={() => handleClientTypeButtonClick(individualClientType)}
					/>
				</StyledSquareButtonContainer>
				<PublicFormButtons
					onBackButtonClick={handleBackButtonClick}
					onContinueButtonClick={handleContinueButtonClick}
					disabled={selectedButton === ''}
				/>
			</Tile>
		</PublicAutoLogoutLayout>
	);
};

export default PublicClientTypeSelectionPage;

export const StyledSquareButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: row;
	flex-wrap: wrap;
	gap: 40px;
`;
